export class CommunityFilter {
    public id: string;
    public groupsIds: string[];

    constructor(id: string, groupsIds: string[]) {
        this.id = id;
        this.groupsIds = groupsIds;
    }
}
